(function(){
  function getWL(){ try{ return JSON.parse(localStorage.getItem('sk_wishlist')||'[]'); }catch(e){ return []; } }
  function setWL(a){ localStorage.setItem('sk_wishlist', JSON.stringify(a)); }
  function updateHeader(){
    var c=getWL().length;
    document.querySelectorAll('[data-wish-count]').forEach(function(el){ el.textContent=c; el.style.display = c>0 ? 'grid' : 'none'; });
  }
  function markActive(){
    var wl=getWL();
    document.querySelectorAll('[data-wish]').forEach(function(b){
      var id=b.getAttribute('data-wish');
      if(wl.indexOf(id)>-1){ b.classList.add('active'); } else { b.classList.remove('active'); }
    });
  }
  function renderPage(){
    var grid=document.querySelector('[data-wishlist-grid]'); if(!grid) return;
    var wl=getWL(), shown=0;
    grid.querySelectorAll('[data-wish-card]').forEach(function(c){
      var id=c.getAttribute('data-wish-card');
      if(wl.indexOf(id)>-1){ c.style.display=''; shown++; } else { c.style.display='none'; }
    });
    var empty=document.querySelector('[data-wishlist-empty]');
    if(empty) empty.style.display = shown===0 ? 'block' : 'none';
    grid.style.display = shown===0 ? 'none' : '';
  }
  document.addEventListener('click', function(e){
    var btn=e.target.closest('.product-card .wish[data-wish]');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var id=btn.getAttribute('data-wish'), wl=getWL(), i=wl.indexOf(id);
    if(i>-1){ wl.splice(i,1); } else { wl.push(id); }
    setWL(wl); markActive(); updateHeader(); renderPage();
  });
  document.addEventListener('sk:wishlist-changed', function(){ updateHeader(); markActive(); renderPage(); });
  function init(){ updateHeader(); markActive(); renderPage(); }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
